module.exports = __webpack_public_path__ + "static/media/petri.7d937623.png";